import MyClinic from './MyClinic';

export default MyClinic;
